export default __webpack_public_path__ + "static/media/esports-active-m.ef39550f.webp";